import Resource from '@/api/resource';

class AttributeResource extends Resource {
  constructor() {
    super('attributes');
  }
}

export { AttributeResource as default };
